(function () {
  'use strict';
  var marker = document.querySelector('[data-scck-simple-settings]');
  if (!marker || window.SCCKSimpleForm) return;
  var config;
  try { config = JSON.parse(marker.textContent); } catch (_) { return; }
  if (!config.enabled) return;
  var root = document.querySelector('.product__info-container');
  if (!root) return;
  var host = document.querySelector('#MainContent') || root.parentElement;
  window.SCCKSimpleForm = { enabled: true, matched: [] };
  var observer;
  var pending = false;

  function field(name) {
    return Array.from(root.querySelectorAll('input,textarea')).find(function (input) {
      return input.name === 'properties[' + name + ']';
    });
  }
  function group(input) { return input && input.closest('.tpo_option-container'); }
  function nativeSet(input, value) {
    var prototype = input.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(prototype, 'value').set;
    setter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('blur', { bubbles: true }));
  }
  function required(input) { return input.required || input.dataset.required === '1'; }
  function label(container, value, input) {
    var text = container.querySelector('.tpo_option-label-container > .form__label');
    if (text && text.textContent.trim() !== value) text.textContent = value;
    if (input && input.getAttribute('aria-label') !== value) input.setAttribute('aria-label', value);
  }
  function hint(container, value) {
    var p = container.querySelector('.scck-simple-hint');
    if (!p) {
      p = document.createElement('p');
      p.className = 'scck-simple-hint';
      var head = container.querySelector('.tpo_option-label-container');
      if (head) head.insertAdjacentElement('afterend', p);
    }
    if (p.textContent !== value) p.textContent = value;
  }
  function register(container, name) {
    container.classList.add('scck-simple-field');
    if (window.SCCKSimpleForm.matched.indexOf(name) < 0) window.SCCKSimpleForm.matched.push(name);
  }
  function colorControl(input, container) {
    label(container, config.color_label, input);
    if (input.placeholder !== config.color_placeholder) input.placeholder = config.color_placeholder;
    var state = window.SCCKSimpleForm;
    if (input.value !== config.help_value) state.savedColor = input.value;
    var existing = container.querySelector('.scck-simple-choice');
    function sync() {
      var current = field('color of inclusions');
      var host = group(current);
      if (!current || !host) return;
      var buttons = host.querySelectorAll('.scck-simple-choice button');
      var note = host.querySelector('.scck-simple-help-message');
      var chooseHelp = current.value === config.help_value;
      if (buttons.length === 2) {
        buttons[0].setAttribute('aria-pressed', String(!chooseHelp));
        buttons[1].setAttribute('aria-pressed', String(chooseHelp));
      }
      host.classList.toggle('scck-help-mode', chooseHelp);
      if (note) note.hidden = !chooseHelp;
    }
    if (existing) { sync(); return; }
    var choices = document.createElement('div');
    choices.className = 'scck-simple-choice';
    choices.setAttribute('role', 'group');
    choices.setAttribute('aria-label', config.color_label);
    var own = document.createElement('button');
    own.type = 'button'; own.textContent = config.own_label;
    var help = document.createElement('button');
    help.type = 'button'; help.textContent = config.help_label;
    choices.append(own, help);
    var message = document.createElement('p');
    message.className = 'scck-simple-help-message';
    message.textContent = config.help_message;
    message.setAttribute('role', 'status');
    var head = container.querySelector('.tpo_option-label-container');
    head.insertAdjacentElement('afterend', choices);
    choices.insertAdjacentElement('afterend', message);
    own.addEventListener('click', function () {
      var current = field('color of inclusions');
      if (!current) return;
      if (current.value === config.help_value) nativeSet(current, state.savedColor || '');
      sync();
      var focus = field('color of inclusions');
      if (focus) focus.focus();
    });
    help.addEventListener('click', function () {
      var current = field('color of inclusions');
      if (!current) return;
      if (current.value !== config.help_value) state.savedColor = current.value;
      nativeSet(current, config.help_value);
      sync();
    });
    sync();
  }
  function extrasControl(input, container) {
    if (required(input)) return;
    var controls = container.querySelector('.tpo_option-type-image-swatches-wrapper');
    var head = container.querySelector('.tpo_option-label-container');
    if (!controls || !head) return;
    container.classList.add('scck-simple-extras');
    label(container, config.extras_label);
    if (container.querySelector('.scck-simple-toggle')) return;
    var button = document.createElement('button');
    button.type = 'button'; button.className = 'scck-simple-toggle';
    if (!controls.id) controls.id = 'scck-extras-' + String(container.id).replace(/[^a-zA-Z0-9-]/g, '-');
    button.setAttribute('aria-controls', controls.id);
    head.appendChild(button);
    var selected = !!container.querySelector('input[type=radio]:checked,input[type=checkbox]:checked') || !!input.value;
    function open(state) {
      container.classList.toggle('scck-extras-open', state);
      button.setAttribute('aria-expanded', String(state));
      button.textContent = state ? config.extras_hide : config.extras_show;
    }
    button.addEventListener('click', function () { open(!container.classList.contains('scck-extras-open')); });
    open(selected);
  }
  function apply() {
    pending = false;
    if (observer) observer.disconnect();
    root = host.querySelector('.product__info-container') || document.querySelector('.product__info-container') || root;
    try {
      [
        ['Inclusions', config.inclusions_label, config.inclusions_hint],
        ['color of inclusions', config.color_label, ''],
        ['Optional Additives', config.extras_label, ''],
        ['Contact', config.contact_label, config.contact_hint],
        ['Share about design', config.notes_label, config.notes_hint]
      ].forEach(function (item) {
        var input = field(item[0]), container = group(input);
        if (!input || !container) return;
        register(container, item[0]);
        if (item[0] === 'color of inclusions') colorControl(input, container);
        else if (item[0] === 'Optional Additives') extrasControl(input, container);
        else {
          var text = item[0] === 'Share about design' && required(input) ? config.notes_required_label : item[1];
          label(container, text, input);
          if (item[2]) hint(container, item[2]);
          if (item[0] === 'Contact' && input.placeholder !== config.contact_placeholder) input.placeholder = config.contact_placeholder;
          if (item[0] === 'Share about design' && input.placeholder !== config.notes_placeholder) input.placeholder = config.notes_placeholder;
        }
      });
    } finally {
      if (observer) observer.observe(host, { childList: true, subtree: true });
    }
  }
  observer = new MutationObserver(function () {
    if (!pending) { pending = true; requestAnimationFrame(apply); }
  });
  apply();
})();
